import React from 'react';
import { useDispatch } from 'react-redux';
import classNames from 'classnames';

import Textarea from '../../../components/Textarea';
import FormInput from '../../../components/FormInput';
import {
  COLORS,
  COMMENT_CONTACT,
  FIRST_COLOR_PALETTE_NUMBER,
} from '../../../utils/const';
import PortfolioCommentIcon from '../../../components/PortfolioCommentIcon';

const { white } = COLORS;

const ContactUsTech = ({
  data: { title, description, fullName, emailOrWebsite },
  locales: { portfolio, portfolioWeb },
  backgroundSection,
  colorPaletteNumber,
  disabled = false,
}) => {
  const scrollToTop = () => {
    const element = document.getElementById('scroll');
    element.scrollIntoView();
  };

  const {
    portfolio: { updateSectionField },
  } = useDispatch();

  const handleChange = (e) => {
    const { name, value } = e.target;

    updateSectionField({
      sectionName: 'contactUs',
      field: name,
      value,
      name,
    });
  };

  const isWhiteText = colorPaletteNumber !== FIRST_COLOR_PALETTE_NUMBER;

  return (
    <div
      className="contact-us-tech relative"
      style={{ background: backgroundSection }}
    >
      <PortfolioCommentIcon title={COMMENT_CONTACT} />
      <div className="header">
        <div
          className={classNames('tech-title title custom-font-title', {
            'text-white': isWhiteText,
          })}
        >
          {portfolio.contactUs.sectionName}
        </div>
        <div>
          <button
            className={classNames('scroll-top custom-font-body', {
              'text-white': isWhiteText,
            })}
            onClick={scrollToTop}
          >
            {portfolioWeb.contactUs.scrollTop}
            <i
              className="icon-Arrow-Top"
              style={{ borderColor: isWhiteText && white }}
            />
          </button>
        </div>
      </div>
      <div className="fields">
        <div className="textarea-techModern description">
          <Textarea
            name="textarea"
            delay={700}
            value={description}
            onChange={(e) =>
              updateSectionField({
                sectionName: 'contactUs',
                field: 'description',
                name: 'contactUsText',
                value: e.target.value,
              })
            }
            className={classNames('textarea-tech custom-font-body', {
              'text-white': isWhiteText,
            })}
            placeholder={portfolio.page.descriptionPlaceholder}
            disabled={disabled}
          />
        </div>
        <FormInput
          name="fullName"
          defaultValue={fullName}
          delay={700}
          placeholder={portfolio.contactUs.newForm.fullName}
          onChange={handleChange}
          disabled={disabled}
          className={classNames('form_input custom-font-body', {
            'text-white': isWhiteText,
          })}
        />
        <FormInput
          name="emailOrWebsite"
          defaultValue={emailOrWebsite}
          delay={700}
          placeholder={portfolio.contactUs.newForm.emailOrWebsite}
          onChange={handleChange}
          disabled={disabled}
          className={classNames('form_input custom-font-body', {
            'text-white': isWhiteText,
          })}
        />
      </div>

      <div
        className={classNames('footer custom-font-body', {
          'text-white': isWhiteText,
        })}
        style={{ borderColor: isWhiteText && white }}
      >
        <div>{`© ${title}. ${portfolioWeb.contactUs.rightsReserve}`}</div>
        <div>
          {portfolioWeb.contactUs.buildCreate}
          <span className="company-name">
            {portfolioWeb.contactUs.companyName}
          </span>
        </div>
      </div>
    </div>
  );
};

export default ContactUsTech;
